import DownArrowIcon from "Assets/Icons/DownArrowIcon";
import EditAttendanceIcon from "Assets/Icons/EditAttendanceIcon";
import EditSmallIcon from "Assets/Icons/EditSmallIcon";
import EyeIcon from "Assets/Icons/EyeIcon";
import {
  Dropdown,
  Menu,
  Tooltip,
  Button as ANTDButton,
  Typography as TY,
  Row,
  Col,
} from "antd";
import GoogleMeetIcon from "Assets/Images/Google_Meet.png";
import Google_Meet_disabled from "Assets/Images/Google_Meet_disabled.png";
import NotMarkedIcon from "Assets/Icons/NotMarkedIcon";
import UpArrowIcon from "Assets/Icons/UpArrowIcon";
import CustomModal from "Components/CommonComponents/CustomModal";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import PDFPageviewer from "Pages/PlannerView/PDFPageviewer";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Collapse } from "reactstrap";
import styled from "styled-components";
import {
  BASE_URL,
  GetViewDocumentURL,
  GET_CONTENT_LICENCE,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import {
  inBetweenTime,
  ScheduleStatus,
  ScheduleStatusColor,
} from "utilFunctions/shared/ScheduleStatus";
import { format, setHours, setMinutes, setSeconds, subDays } from "date-fns";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import {
  CLASS_URL_ENCODE_STRING,
  UPLOAD_ASSET_LASTDATE,
} from "utilFunctions/Constants/Constants";
import { Buffer } from "buffer";
import CrystalLink from "Assets/Icons/CrystalLink";
import VideoPlayer from "Pages/AssetView/VideoPlayer";
import { DownOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";
import ErrorView from "Pages/AssetView/ErrorView";
import moment from "moment";
// import UploadFileDrawer from "Components/UploadFileDrawer"; // Import the new component
import UploadAssetDrawer from "Components/UploadAssetDrawer";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
import useViewAccess from "Pages/MySchedule/Hooks/useViewAccess";
import { capitalizeFirstLetter } from "Pages/StudentPortfolio/StudentCommentSection/StudentCommentListingBox";
import ArrowUpRight from "Assets/Icons/ArrowUpRightIcon";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
// import AssetViewerModal from "Components/AssetViewerModal";
const { Text } = TY;

interface IScheduledLectureCardView {
  cardData?: any;
  screen?: any;
  cardIndex?: any;
  handleJoinLecture?: any;
  handleMarkSyllbus?: any;
  mode?: any;
  buttonCSS?: any;
  detailShowHandler?: any;
  totalCards?: number;
  dateRanges?: any;
  filterState?: any;
}
const ScheduleDiv: any = styled<any>("div")`
  background-color #fff;
  display:flex;
  width: ${({ mode, screen }: any) =>
    ["dashboard"].includes(mode)
      ? ["xs", "sm", "md"].includes(screen)
        ? "100%"
        : "100%"
      : ["schedule"].includes(mode) && ["xs", "sm", "md"].includes(screen)
      ? "100%"
      : "100%"};
  border: 1px solid #cccccc;
  border-radius: 5px;
  border-left: 8px solid ${({ color }: any) => color};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "16px" : "16px"};
  margin-bottom: 12px;
  flex-direction: column;
`;
const MainDiv: any = styled<any>("div")`
  background-color #fff;
  display:flex;
  flex-direction: ${({ mode, screen, totalCards }: any) =>
    ["dashboard"].includes(mode)
      ? totalCards > 1
        ? "column"
        : ["xs", "sm", "md"].includes(screen)
        ? "column"
        : "row"
      : ["schedule"].includes(mode) && ["xs", "sm", "md"].includes(screen)
      ? "column"
      : "row"};
  width: 100%;
  gap: 16px;
`;
const Div1: any = styled<any>("div")`
  width: 100%;
  white-space: nowrap;
`;
const Div2: any = styled<any>("div")`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
`;
const HeadingDiv: any = styled<any>("div")`
  font-weight: 700;
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "14px" : "16px"};
  color: #333333;
`;
const HeadingDiv1: any = styled<any>("div")`
  display: flex;
  justify-content: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "space-between" : ""};
  margin-bottom: 4px;
`;
const SubHeadingDiv: any = styled<any>("div")`
  font-weight: 400;
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : "14px"};
  color: #757575;
`;
const StyledDropdown = styled(Dropdown)`
  .ant-dropdown-menu-item {
    padding: 15px !important;
  }
  .ant-dropdown-menu-submenu-title {
    padding: 15px !important;
  }
`;
function ScheduledLectureCard({
  cardData,
  screen,
  cardIndex,
  handleMarkSyllbus,
  mode,
  buttonCSS,
  detailShowHandler,
  totalCards,
  dateRanges,
  filterState,
}: IScheduledLectureCardView) {
  const ToastDispatch = useContext(ToastContextDispatch);
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { isViewOnly } = useViewAccess({
    UserRoleAccess: [UserRoles.academicCounsellor],
  });
  const navigate = useNavigate();
  const [pdfPassword, setPdfPassword] = useState<string | null>(null);
  const [isOpenCollapse, setisOpenCollapse] = useState<boolean>(false);
  const [isPaneOpen, setIsPaneOpen] = useState<boolean>();
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [assetViewOpen, setAssetViewOpen] = useState<boolean>(false);
  const [contentType, setContentType] = useState<any>(null);
  const [items, setItems] = useState<any>([]);
  const [open, setOpen] = useState<boolean>(false);

  const { lectureAssetAccess } = userInfo;
  const canPerformUpload =
    lectureAssetAccess && Object.keys(lectureAssetAccess).length > 0;

  const handleUploadFile = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onUploadSuccess = (data: any) => {
    console.log("File uploaded successfully:", data);
  };

  const cardViewData = cardData;
  console.log("cardViewDatacardViewData", cardViewData);
  const { makeRequest: GetViewDocument } = useGetApi(
    (data: any) => {
      if (data && data["detailMessage"]) {
        setIsPaneOpen(!isPaneOpen);
        setPdfUrl(data["detailMessage"]);
      }
    },
    (error: any) => {
      setPdfUrl("");
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    if (cardData && cardData.lectureContent && cardData.lectureContent.ebooks) {
      const arr = cardData.lectureContent.ebooks.map(
        (ele: any, index: number) => {
          const arr = ele?.url?.split("/");
          const fileName = arr[arr.length - 1];
          return {
            key: index + 1,
            label: fileName,
            url: ele?.url,
            client: ele?.client,
          };
        }
      );
      setItems(arr);
    }
  }, [cardData]);
  const returnDisableHandler = (cardViewData: any) => {
    let retValue = true;
    if (
      cardViewData?.eventLink &&
      ["DEMO CLASS", "PTM", "ORIENTATION"].includes(cardViewData.eventType)
    ) {
      retValue = false;
    } else if (cardViewData.courseId && cardViewData.courseId != null) {
      retValue = false;
    } else {
      if (cardViewData.eventLink) {
        retValue = false;
      }
      retValue = true;
    }
    return retValue;
  };
  const getViewDocumentHandler = (cardViewData: any) => {
    GetViewDocument(
      BASE_URL + GetViewDocumentURL + "?s3Key=" + cardViewData.documentS3Key
    );
  };
  const handleMarkAttendance = (data: any, type: any) => {
    if (data) {
      navigate("/admin/schedule/attendance/" + data.batchTimeTableId, {
        replace: false,
        state: {
          referrer: location.pathname,
          selectedSchedule: data,
          attendanceStatus: type,
          courseId: data?.courseId,
          dateRanges,
          filterState,
        },
      });
    } else {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "CourseId not present",
      });
    }
  };

  const mnEncodeBase64 = (data: any) => {
    const key = CLASS_URL_ENCODE_STRING;
    let temp: any = Buffer.from(data).toString("base64");
    const mapObj: { [key: string]: string } = {
      "+": "@",
      "/": "$",
      "=": "!",
      "&": "^",
      "?": "#",
    };

    for (const key in mapObj) {
      if (Object.prototype.hasOwnProperty.call(mapObj, key)) {
        while (temp.indexOf(key) !== -1) {
          temp = temp.replace(key, mapObj[key]);
        }
      }
    }
    return key + temp;
  };
  function processEventLink(input: string | null, substring: string): any {
    if (!input || input.trim() === "" || !input.includes(substring)) {
      return input;
    }

    const splitOnQuestionMark = input.split("?");
    if (splitOnQuestionMark.length !== 2) {
      return null;
    }

    const roomId = splitOnQuestionMark[1].split("=");
    if (roomId.length !== 2) {
      return null;
    }

    const isPresenter = "1";
    const encId = mnEncodeBase64(
      roomId[1] + "_" + userInfo.employeeId + "_" + `${isPresenter}` + "_1"
    );

    return splitOnQuestionMark[0] + `/${encId}`;
  }
  const { makeRequest: fetchFileDecryptionKey } = useGetApi(
    (data: any) => {
      if (data?.detailMessage) {
        const decodedKey = atob(data?.detailMessage);
        setPdfPassword(decodedKey);
      } else {
        setPdfPassword("NO_PASSWORD");
      }
    },
    (error: any) => {
      setPdfPassword("NO_PASSWORD");
      console.error(error);
    }
  );

  const onClickViewPdf: any = ({ key }: any) => {
    handleOpenAsset("ebook");
    setAssetViewOpen(true);
    const data = items.find((ele: any) => ele.key == key);
    let courseId = cardViewData?.courseId;
    if (data?.client == "CRYSTAL" && (!courseId || courseId == null)) {
      courseId = "000";
    }
    fetchFileDecryptionKey(
      BASE_URL +
        GET_CONTENT_LICENCE +
        `?assetId=${cardViewData.batchTimeTableId}&courseId=${courseId}&source=${data?.client}`
    );
    setContentType({
      type: "ebook",
      data: data?.url,
      client: data?.client,
    });
  };
  // const dateViewDatas = cardViewData?.endTime.split("T")[0];
  const dateViewDatas = moment(cardViewData?.endTime)
    .utcOffset("+05:30")
    .format()
    .split("T")[0];
  const todayDates = moment().utcOffset("+05:30").format().split("T")[0];
  const past7Days = format(
    setSeconds(setMinutes(setHours(subDays(new Date(), 5), 18), 30), 0),
    "yyyy-MM-dd"
  );
  const time = moment(cardViewData?.endTime);
  const checkValidation = () => {
    let retVal = false;
    if (userInfo?.fexRole == "Faculty" && dateViewDatas == todayDates) {
      retVal = false;
    } else if (
      userInfo?.fexRole != "Faculty" &&
      (time.isBetween(past7Days, todayDates) || dateViewDatas == todayDates)
    ) {
      retVal = false;
    } else {
      retVal = true;
    }
    return retVal;
  };
  const isSmallScreen = ["xs", "sm", "md"].includes(screen);

  const isUploadAllowedByStatus = !(
    cardViewData?.syllabusStatus == "Upcoming" ||
    new Date(cardViewData?.endTime) < new Date(UPLOAD_ASSET_LASTDATE) ||
    inBetweenTime(cardViewData?.startTime, cardViewData?.endTime) ||
    ["DEMO CLASS", "PTM", "ORIENTATION"].includes(cardViewData?.eventType)
  );
  const returnTitle = (cardViewData: any, contentType: any) => {
    const name =
      cardViewData.eventName != null
        ? cardViewData.eventName
        : cardViewData?.eventType;
    if (contentType) {
      return contentType.type == "video" ? name + " Video" : name + " PDF";
    } else {
      return " ";
    }
  };
  const qouteToQuizPage = () => {
    const query = encodeURIComponent(JSON.stringify(cardViewData));

    window.open(
      `/admin/quiz/${cardViewData.batchTimeTableId}?data=${query}`,
      "_blank"
    );
  };

  const handleViewLibrary = () => {
    if (mode === "schedule") {
      pushToDataLayerForGTM({
        event: "ag_lecture_view_library_from_schedule",
        USER_ROLE: userInfo?.fexRole,
        EMPLOYEE_ID: userInfo?.employeeId,
      });
    }
    detailShowHandler(cardViewData);
  };

  const handleQuizClick = () => {
    if (mode === "schedule") {
      pushToDataLayerForGTM({
        event: "ag_lecture_quiz_from_schedule",
        USER_ROLE: userInfo?.fexRole,
        EMPLOYEE_ID: userInfo?.employeeId,
      });
    }
    qouteToQuizPage();
  };

  const handleUploadClick = () => {
    handleUploadFile();
  };

  const handleOpenAsset = (assetType: any) => {
    if (mode === "schedule") {
      pushToDataLayerForGTM({
        event: "ag_lecture_open_asset",
        ASSET_TYPE: assetType,
        LECTURE_ID: cardViewData?.fexRecordId ?? cardViewData?.batchTimeTableId,
      });
    }
  };

  const handleOpenVideo = () => {
    handleOpenAsset("video");
    setAssetViewOpen(true);
    setContentType({
      type: "video",
      data:
        cardViewData.lectureContent.videos &&
        cardViewData.lectureContent.videos.length &&
        cardViewData.lectureContent.videos[0]?.url,
      client:
        cardViewData.lectureContent.videos &&
        cardViewData.lectureContent.videos.length &&
        cardViewData.lectureContent.videos[0]?.client,
    });
  };

  interface AttendanceData {
    updatedByEmail: string;
    updatedAt: string;
    attendanceStatus: string;
    eventType: string;
    takeAttendance: boolean;
    syllabusStatus: string;
  }

  const renderUpdateTooltip = (data: AttendanceData) => {
    const { updatedByEmail, updatedAt } = data || {};
    if (!updatedByEmail) return null;

    return (
      /* Tooltip content - manual arrow div is removed */
      <div
        style={{
          display: "flex",
          gap: "6px",
          whiteSpace: "nowrap",
          alignItems: "center",
          color: "#333", // Text color over the light-gray background
          fontWeight: "bold",
        }}
      >
        <span>Last Updated by</span>
        <span>{updatedByEmail}</span>
        <span>·</span>
        <span>
          {updatedAt ? moment.utc(updatedAt).utcOffset("+05:30").fromNow() : ""}
        </span>
      </div>
    );
  };

  const wrapWithUpdateTooltip = (
    buttonElement: React.ReactNode,
    data: AttendanceData
  ) => {
    const shouldShowTooltip =
      data?.updatedByEmail && data?.attendanceStatus !== "Unmarked";

    const wrapperStyle: React.CSSProperties = {
      display: "inline-flex",
      verticalAlign: "middle",
      marginLeft: "16px",
    };

    if (!shouldShowTooltip) {
      return <span style={wrapperStyle}>{buttonElement}</span>;
    }

    return (
      <Tooltip
        title={renderUpdateTooltip(data)}
        color="#dbdee1"
        placement="bottom" // Changed from bottomLeft to bottom for natural centering
        mouseEnterDelay={0.3}
        // Force native arrow to point exactly at the horizontal center of the target element
        arrow={{ pointAtCenter: true }}
        styles={{
          body: {
            whiteSpace: "nowrap",
            width: "max-content",
            borderRadius: "6px",
            padding: "6px 12px",
            fontSize: "13px",
          },
        }}
        // Removed the hardcoded 'align offset' properties which broke responsiveness
        style={wrapperStyle}
      >
        <div>{buttonElement}</div>
      </Tooltip>
    );
  };

  console.log("cardViewDatacardViewData", cardViewData);
  return (
    <>
      <UploadAssetDrawer
        open={open}
        onClose={onClose}
        onUploadSuccess={onUploadSuccess}
        BASE_URL={BASE_URL}
        lectureId={cardViewData?.batchTimeTableId}
        courseId={cardViewData?.courseId}
        prevContent={cardViewData?.lectureContent}
        videoAccess={lectureAssetAccess?.videoAccess || []}
        pdfAccess={lectureAssetAccess?.pdfAccess || []}
      />
      <ScheduleDiv
        key={cardIndex}
        color={ScheduleStatusColor(
          inBetweenTime(cardViewData?.startTime, cardViewData?.endTime)
            ? "Ongoing"
            : cardViewData.syllabusStatus
        )}
        screen={screen}
        mode={mode}
      >
        <CustomModal
          modal={isPaneOpen}
          centered={true}
          backdrop={true}
          size={"xl"}
          fullscreen={true}
          className="document-viewer-fullscreen-modal"
          title={cardViewData?.eventName}
          toggle={() => {
            setIsPaneOpen(false);
            setPdfUrl("");
          }}
        >
          <div
            className="modern-asset-viewer-container w-100 d-flex align-items-center justify-content-center"
            style={{
              height: "100vh",
              maxHeight: "100vh",
              overflow: "hidden",
              background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
              padding: "0",
            }}
          >
            <PDFPageviewer
              allPageInOne={true}
              pdfUrl={pdfUrl}
              isLibraryView={true}
            />
          </div>
        </CustomModal>
        {/* <AssetViewerModal
          isOpen={assetViewOpen} // Replace with the state controlling the modal visibility
          onClose={() => {
            setAssetViewOpen(false);
          }} // Replace with the function to close the modal
          contentType={contentType} // Replace with the content type (video or ebook)
          pdfPassword={pdfPassword} // Replace with the PDF password if applicable
          title={
            contentType
              ? contentType.type == "video"
                ? cardViewData.eventName + " Video"
                : cardViewData.eventName + " PDF"
              : " "
          } // Replace with the title for the modal
          assetId={cardViewData.batchTimeTableId} // Replace with the asset ID if applicable
        /> */}
        <CustomModal
          modal={assetViewOpen}
          centered={true}
          backdrop={true}
          size={contentType && contentType.type == "video" ? "lg" : "xl"}
          fullscreen={true}
          className={
            contentType?.type === "ebook"
              ? "document-viewer-fullscreen-modal"
              : undefined
          }
          title={returnTitle(cardViewData, contentType)}
          toggle={() => {
            setAssetViewOpen(false);
          }}
        >
          <div
            className="modern-asset-viewer-container w-100 d-flex align-items-center justify-content-center"
            style={{
              height: "100vh",
              maxHeight: "100vh",
              overflow: "hidden",
              background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
              padding: contentType?.type === "video" ? "20px" : "0",
            }}
          >
            {contentType ? (
              contentType.type == "video" ? (
                <div className="modern-video-wrapper">
                  <div className="video-player-container">
                    <VideoPlayer
                      videoUrl={contentType.data}
                      JWTToken={""}
                      assetId={cardViewData.batchTimeTableId}
                      source={contentType.client}
                    />
                  </div>
                </div>
              ) : contentType?.data != "" && pdfPassword != null ? (
                <PDFPageviewer
                  allPageInOne={true}
                  pdfUrl={contentType?.data}
                  pdfPassword={pdfPassword}
                  isLibraryView={true}
                  source={contentType.client}
                  parentComponent={"AssetViewerModal"}
                />
              ) : (
                <ErrorView />
              )
            ) : null}
          </div>
        </CustomModal>
        <MainDiv mode={mode} screen={screen} totalCards={totalCards}>
          <Div1>
            {" "}
            <HeadingDiv1 screen={screen}>
              <div className="d-flex">
                <HeadingDiv screen={screen}>
                  <span className="pr-2">
                    {convertTime(cardViewData?.startTime, "h:mm")} -
                  </span>
                  <span>
                    {convertTime(cardViewData?.endTime, "h:mm a")} |&nbsp;
                  </span>
                </HeadingDiv>
                <HeadingDiv screen={screen}>
                  <Tooltip title={cardViewData?.eventType}>
                    <span>
                      {cardViewData.eventName
                        ? cardViewData.eventName
                        : cardViewData.eventType}
                    </span>
                  </Tooltip>
                </HeadingDiv>
              </div>
              <div className="cardStatusChip">
                <ScheduleStatus
                  status={
                    inBetweenTime(
                      cardViewData?.startTime,
                      cardViewData?.endTime
                    )
                      ? "Ongoing"
                      : cardViewData?.syllabusStatus &&
                        cardViewData?.syllabusStatus != null &&
                        cardViewData?.syllabusStatus.toUpperCase() == "NA"
                      ? ""
                      : cardViewData?.syllabusStatus &&
                        cardViewData?.syllabusStatus != null
                      ? cardViewData.syllabusStatus
                      : ""
                  }
                ></ScheduleStatus>
              </div>
            </HeadingDiv1>
            <div className="d-flex">
              <SubHeadingDiv screen={screen}>
                {cardViewData.batchName} |&nbsp;
              </SubHeadingDiv>
              <SubHeadingDiv screen={screen}>{cardViewData.room}</SubHeadingDiv>
            </div>
          </Div1>
          <Div2>
            {!isOpenCollapse && (
              <div className="d-flex w-100 justify-content-end">
                {cardViewData.syllabusStatus == "Upcoming" ? (
                  <div className="d-flex flex-row">
                    {!isViewOnly &&
                      cardViewData?.eventLink &&
                      cardViewData?.eventLink != null && (
                        <Button
                          outline
                          size="sm"
                          disabled={returnDisableHandler(cardViewData)}
                          color={
                            returnDisableHandler(cardViewData)
                              ? "aeslDraft"
                              : "aeslPrimary"
                          }
                          onClick={() =>
                            window.open(
                              processEventLink(
                                cardViewData?.eventLink,
                                "crystal"
                              ),
                              "_blank"
                            )
                          }
                          className={`${buttonCSS} no-hover-effect buttonHeight d-flex align-items-center gap-2`}
                        >
                          {["PTM", "ORIENTATION"].includes(
                            cardViewData.eventType
                          ) ? (
                            <>Join meeting </>
                          ) : (
                            <>Join lecture</>
                          )}
                          {returnDisableHandler(cardViewData) ? (
                            <img
                              width={16}
                              height={12}
                              src={Google_Meet_disabled}
                            />
                          ) : cardViewData?.eventLink != null &&
                            cardViewData?.eventLink.includes("crystal") ? (
                            <CrystalLink id="UncontrolledTooltipMeetlink" />
                          ) : (
                            <img
                              width={16}
                              height={12}
                              src={GoogleMeetIcon}
                              id="UncontrolledTooltipMeetlink"
                            />
                          )}
                        </Button>
                      )}
                  </div>
                ) : cardViewData.syllabusStatus == "Marked" ? (
                  <div className="d-flex flex-row">
                    {cardViewData &&
                    [
                      "LECTURE",
                      "EXTRA CLASS",
                      "DOUBT CLASS",
                      "PTM",
                      "ORIENTATION",
                    ].includes(cardViewData.eventType) &&
                    cardViewData?.takeAttendance
                      ? cardViewData.attendanceStatus == "Unmarked"
                        ? wrapWithUpdateTooltip(
                            <Button
                              outline
                              size="sm"
                              color="aeslPrimary"
                              onClick={() => {
                                handleMarkAttendance(cardViewData, "mark");
                              }}
                              className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {!checkValidation()
                                ? "Take Attendance"
                                : "View Attendance"}
                              &nbsp;
                              <EditSmallIcon />
                            </Button>,
                            cardViewData
                          )
                        : wrapWithUpdateTooltip(
                            <Button
                              outline
                              size="sm"
                              color="aeslPrimary"
                              onClick={() => {
                                handleMarkAttendance(cardViewData, "edit");
                              }}
                              className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {!checkValidation()
                                ? "Edit Attendance"
                                : "View Attendance"}
                              &nbsp;
                              <EditAttendanceIcon />
                            </Button>,
                            cardViewData
                          )
                      : null}
                    {!isViewOnly && cardViewData?.markLecture && (
                      <Button
                        outline
                        size="sm"
                        color={
                          returnDisableHandler(cardViewData)
                            ? "aeslDraft"
                            : "aeslPrimary"
                        }
                        disabled={returnDisableHandler(cardViewData)}
                        onClick={() => {
                          handleMarkSyllbus(cardViewData, "view");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight`}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        View Syllabus <EyeIcon />
                      </Button>
                    )}
                  </div>
                ) : cardViewData.syllabusStatus == "Unmarked" ||
                  inBetweenTime(
                    cardViewData?.startTime,
                    cardViewData?.endTime
                  ) ? (
                  <div className="d-flex flex-row">
                    {cardViewData &&
                    [
                      "LECTURE",
                      "EXTRA CLASS",
                      "DOUBT CLASS",
                      "PTM",
                      "ORIENTATION",
                    ].includes(cardViewData.eventType) &&
                    cardViewData?.takeAttendance
                      ? cardViewData.attendanceStatus == "Unmarked"
                        ? wrapWithUpdateTooltip(
                            <Button
                              outline
                              size="sm"
                              color="aeslPrimary"
                              onClick={() => {
                                handleMarkAttendance(cardViewData, "mark");
                              }}
                              className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {!checkValidation()
                                ? "Take Attendance"
                                : "View Attendance"}
                              &nbsp;
                              <EditSmallIcon />
                            </Button>,
                            cardViewData
                          )
                        : wrapWithUpdateTooltip(
                            <Button
                              outline
                              size="sm"
                              color="aeslPrimary"
                              onClick={() => {
                                handleMarkAttendance(cardViewData, "edit");
                              }}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                              className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                            >
                              {!checkValidation()
                                ? "Edit Attendance"
                                : "View Attendance"}
                              &nbsp;
                              <EditAttendanceIcon />
                            </Button>,
                            cardViewData
                          )
                      : null}
                    {!isViewOnly &&
                      new Date(new Date()) < new Date(cardViewData?.endTime) &&
                      cardViewData?.eventLink &&
                      cardViewData?.eventLink != null && (
                        <Button
                          outline
                          size="sm"
                          color={"aeslPrimary"}
                          onClick={() =>
                            window.open(
                              processEventLink(
                                cardViewData?.eventLink,
                                "crystal"
                              ),
                              "_blank"
                            )
                          }
                          className={`${buttonCSS} no-hover-effect buttonHeight d-flex align-items-center gap-2`}
                        >
                          Join lecture&nbsp;
                          {cardViewData?.eventLink != null &&
                          cardViewData?.eventLink.includes("crystal") ? (
                            <CrystalLink id="UncontrolledTooltipMeetlink" />
                          ) : (
                            <img
                              width={16}
                              height={12}
                              src={GoogleMeetIcon}
                              id="UncontrolledTooltipMeetlink"
                            />
                          )}
                        </Button>
                      )}

                    {inBetweenTime(
                      cardViewData?.startTime,
                      cardViewData?.endTime
                    ) ? null : !isViewOnly && cardViewData?.markLecture ? (
                      <Button
                        outline
                        size="sm"
                        color={
                          returnDisableHandler(cardViewData)
                            ? "aeslDraft"
                            : "aeslPrimary"
                        }
                        disabled={returnDisableHandler(cardViewData)}
                        onClick={() => {
                          handleMarkSyllbus(cardViewData, "mark");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight`}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        Mark Syllabus{" "}
                        <NotMarkedIcon
                          color={
                            returnDisableHandler(cardViewData) ? "#757575" : ""
                          }
                        />
                      </Button>
                    ) : null}
                  </div>
                ) : (
                  <div className="d-flex flex-row">
                    {cardViewData &&
                    [
                      "LECTURE",
                      "EXTRA CLASS",
                      "DOUBT CLASS",
                      "PTM",
                      "ORIENTATION",
                    ].includes(cardViewData.eventType) &&
                    cardViewData?.takeAttendance
                      ? cardViewData.attendanceStatus == "Unmarked"
                        ? wrapWithUpdateTooltip(
                            <Button
                              outline
                              size="sm"
                              color="aeslPrimary"
                              onClick={() => {
                                handleMarkAttendance(cardViewData, "mark");
                              }}
                              className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {!checkValidation()
                                ? "Take Attendance"
                                : "View Attendance"}
                              &nbsp;
                              <EditSmallIcon />
                            </Button>,
                            cardViewData
                          )
                        : wrapWithUpdateTooltip(
                            <Button
                              outline
                              size="sm"
                              color="aeslPrimary"
                              onClick={() => {
                                handleMarkAttendance(cardViewData, "edit");
                              }}
                              className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {!checkValidation()
                                ? "Edit Attendance"
                                : "View Attendance"}
                              &nbsp;
                              <EditAttendanceIcon />
                            </Button>,
                            cardViewData
                          )
                      : null}
                  </div>
                )}
              </div>
            )}

            {mode && mode != "dashboard" && (
              <div
                className="ml-3 cursor-pointer d-flex algn-items-center"
                onClick={() => {
                  setisOpenCollapse(!isOpenCollapse);
                }}
              >
                {isOpenCollapse ? <UpArrowIcon /> : <DownArrowIcon />}
              </div>
            )}
          </Div2>
        </MainDiv>
        {mode && mode != "dashboard" && (
          <div>
            <Collapse isOpen={isOpenCollapse} className="scheduledCollapseCard">
              <Row>
                <Col span={12}>
                  <Row gutter={[10, 10]}>
                    <Col span={24}>
                      <Text
                        strong
                        style={{
                          fontSize: isSmallScreen ? 12 : 16,
                          color: "black",
                        }}
                      >
                        Basic Details
                      </Text>
                    </Col>
                    <Col span={8} className="d-flex flex-row capitalize">
                      <Text
                        type="secondary"
                        style={{ fontSize: 14, fontWeight: "800" }}
                      >
                        Batch:
                      </Text>{" "}
                    </Col>
                    {cardViewData.batchId && cardViewData.batchName ? (
                      <Col span={16}>
                        <span
                          className="filterSpan pl-1"
                          onClick={() => {
                            navigate("/admin/mybatch/" + cardViewData.batchId, {
                              replace: false,
                            });
                          }}
                        >
                          {cardViewData?.batchName}
                        </span>
                      </Col>
                    ) : (
                      <Col span={16}>
                        <Text style={{ fontSize: 14 }}>-</Text>
                      </Col>
                    )}

                    <Col span={8}>
                      <Text
                        type="secondary"
                        style={{ fontSize: 14, fontWeight: "800" }}
                      >
                        Class:
                      </Text>{" "}
                    </Col>
                    <Col span={16}>
                      <Text style={{ fontSize: 14 }}>
                        {capitalizeFirstLetter(
                          cardViewData?.class != null ? cardViewData.class : ""
                        )}
                      </Text>
                    </Col>

                    <Col span={8}>
                      <Text
                        type="secondary"
                        style={{ fontSize: 14, fontWeight: "800" }}
                      >
                        Room:
                      </Text>{" "}
                    </Col>
                    <Col span={16}>
                      <Text style={{ fontSize: 14 }}>
                        {capitalizeFirstLetter(
                          cardViewData?.room != null ? cardViewData.room : ""
                        )}
                      </Text>
                    </Col>

                    <Col span={8}>
                      <Text
                        type="secondary"
                        style={{ fontSize: 14, fontWeight: "800" }}
                      >
                        Subject:
                      </Text>{" "}
                    </Col>
                    <Col span={16}>
                      <Text style={{ fontSize: 14 }}>
                        {capitalizeFirstLetter(
                          cardViewData?.subject && cardViewData.subject != null
                            ? cardViewData.subject.charAt(0).toUpperCase() +
                                cardViewData.subject.slice(1).toLowerCase()
                            : ""
                        )}
                      </Text>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={isSmallScreen ? 24 : 12}
                  className={isSmallScreen ? "" : "pl-3"}
                >
                  <Row gutter={[10, 10]}>
                    <Col span={24}>
                      <Text
                        strong
                        style={{
                          fontSize: isSmallScreen ? 12 : 16,
                          color: "black",
                        }}
                      >
                        Actions
                      </Text>
                    </Col>
                    <>
                      {cardViewData.syllabusStatus == "Upcoming" ? (
                        <>
                          {!isViewOnly &&
                            cardViewData?.eventLink &&
                            cardViewData?.eventLink != null && (
                              <>
                                <Col span={12} className="d-flex">
                                  <span className="filterSpan">
                                    {["PTM", "ORIENTATION"].includes(
                                      cardViewData.eventType
                                    ) ? (
                                      <>Join meeting </>
                                    ) : (
                                      <>Join lecture </>
                                    )}
                                  </span>
                                </Col>
                                <Col span={12}>
                                  <ANTDButton
                                    size="small"
                                    disabled={returnDisableHandler(
                                      cardViewData
                                    )}
                                    type={
                                      returnDisableHandler(cardViewData)
                                        ? "default"
                                        : "text"
                                    }
                                    onClick={() =>
                                      window.open(
                                        processEventLink(
                                          cardViewData?.eventLink,
                                          "crystal"
                                        ),
                                        "_blank"
                                      )
                                    }
                                    icon={
                                      <>
                                        {returnDisableHandler(cardViewData) ? (
                                          <img
                                            width={16}
                                            height={12}
                                            src={Google_Meet_disabled}
                                          />
                                        ) : cardViewData?.eventLink != null &&
                                          cardViewData?.eventLink.includes(
                                            "crystal"
                                          ) ? (
                                          <CrystalLink
                                            id="UncontrolledTooltipMeetlink"
                                            style={{
                                              width: 18,
                                              height: 18,
                                            }}
                                          />
                                        ) : (
                                          <img
                                            width={16}
                                            height={12}
                                            src={GoogleMeetIcon}
                                            id="UncontrolledTooltipMeetlink"
                                          />
                                        )}
                                      </>
                                    }
                                  ></ANTDButton>
                                </Col>
                              </>
                            )}
                        </>
                      ) : cardViewData.syllabusStatus == "Marked" ? (
                        <>
                          {cardViewData &&
                          [
                            "LECTURE",
                            "EXTRA CLASS",
                            "DOUBT CLASS",
                            "PTM",
                            "ORIENTATION",
                          ].includes(cardViewData.eventType) &&
                          cardViewData?.takeAttendance ? (
                            cardViewData.attendanceStatus == "Unmarked" ? (
                              <>
                                <Col span={12} className="d-flex">
                                  <span
                                    className="filterSpan"
                                    onClick={() => {
                                      handleMarkAttendance(
                                        cardViewData,
                                        "mark"
                                      );
                                    }}
                                  >
                                    {!checkValidation()
                                      ? "Take Attendance"
                                      : "View Attendance"}
                                  </span>
                                </Col>
                                <Col span={12}>
                                  <ANTDButton
                                    size="small"
                                    type="text"
                                    onClick={() => {
                                      handleMarkAttendance(
                                        cardViewData,
                                        "mark"
                                      );
                                    }}
                                    icon={<EditSmallIcon />}
                                  ></ANTDButton>
                                </Col>
                              </>
                            ) : (
                              <>
                                <Col span={12} className="d-flex">
                                  <span className="filterSpan">
                                    {!checkValidation()
                                      ? "Edit Attendance"
                                      : "View Attendance"}
                                  </span>
                                </Col>
                                <Col span={12}>
                                  <Button
                                    size="small"
                                    color="primary"
                                    onClick={() => {
                                      handleMarkAttendance(
                                        cardViewData,
                                        "edit"
                                      );
                                    }}
                                    className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                                  >
                                    <EditAttendanceIcon />
                                  </Button>
                                </Col>
                              </>
                            )
                          ) : null}
                          {!isViewOnly && cardViewData?.markLecture && (
                            <>
                              <Col span={12} className="d-flex">
                                <span className="filterSpan">
                                  {" "}
                                  View Syllabus
                                </span>
                              </Col>
                              <Col span={12}>
                                <ANTDButton
                                  size="small"
                                  type={
                                    returnDisableHandler(cardViewData)
                                      ? "default"
                                      : "primary"
                                  }
                                  disabled={returnDisableHandler(cardViewData)}
                                  onClick={() => {
                                    handleMarkSyllbus(cardViewData, "view");
                                  }}
                                  icon={<EyeOutlined />}
                                ></ANTDButton>
                              </Col>
                            </>
                          )}
                        </>
                      ) : cardViewData.syllabusStatus == "Unmarked" ||
                        inBetweenTime(
                          cardViewData?.startTime,
                          cardViewData?.endTime
                        ) ? (
                        <>
                          {cardViewData &&
                          [
                            "LECTURE",
                            "EXTRA CLASS",
                            "DOUBT CLASS",
                            "PTM",
                            "ORIENTATION",
                          ].includes(cardViewData.eventType) &&
                          cardViewData?.takeAttendance ? (
                            cardViewData.attendanceStatus == "Unmarked" ? (
                              <>
                                <Col span={12} className="d-flex">
                                  <span className="filterSpan">
                                    {!checkValidation()
                                      ? "Take Attendance"
                                      : "View Attendance"}
                                  </span>
                                </Col>
                                <Col span={12}>
                                  <ANTDButton
                                    size="small"
                                    color="primary"
                                    type="text"
                                    onClick={() => {
                                      handleMarkAttendance(
                                        cardViewData,
                                        "mark"
                                      );
                                    }}
                                    icon={<EditSmallIcon />}
                                  ></ANTDButton>
                                </Col>
                              </>
                            ) : (
                              <>
                                <Col span={12} className="d-flex">
                                  <span className="filterSpan">
                                    {!checkValidation()
                                      ? "Edit Attendance"
                                      : "View Attendance"}
                                    &nbsp;
                                  </span>
                                </Col>
                                <Col span={12}>
                                  {" "}
                                  <ANTDButton
                                    size="small"
                                    type="primary"
                                    onClick={() => {
                                      handleMarkAttendance(
                                        cardViewData,
                                        "edit"
                                      );
                                    }}
                                    className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                                    icon={<EditAttendanceIcon />}
                                  ></ANTDButton>
                                </Col>
                              </>
                            )
                          ) : null}
                          {!isViewOnly &&
                            new Date(new Date()) <
                              new Date(cardViewData?.endTime) &&
                            cardViewData?.eventLink &&
                            cardViewData?.eventLink != null && (
                              <>
                                <Col span={12} className="d-flex">
                                  <span className="filterSpan">
                                    Join lecture&nbsp;
                                  </span>
                                </Col>
                                <Col span={12}>
                                  <ANTDButton
                                    size="small"
                                    type={"primary"}
                                    onClick={() =>
                                      window.open(
                                        processEventLink(
                                          cardViewData?.eventLink,
                                          "crystal"
                                        ),
                                        "_blank"
                                      )
                                    }
                                    icon={
                                      <>
                                        {cardViewData?.eventLink != null &&
                                        cardViewData?.eventLink.includes(
                                          "crystal"
                                        ) ? (
                                          <CrystalLink id="UncontrolledTooltipMeetlink" />
                                        ) : (
                                          <img
                                            width={16}
                                            height={12}
                                            src={GoogleMeetIcon}
                                            id="UncontrolledTooltipMeetlink"
                                          />
                                        )}
                                      </>
                                    }
                                  ></ANTDButton>
                                </Col>
                              </>
                            )}

                          {inBetweenTime(
                            cardViewData?.startTime,
                            cardViewData?.endTime
                          ) ? null : !isViewOnly &&
                            cardViewData?.markLecture ? (
                            <>
                              <Col span={12} className="d-flex">
                                <span className="filterSpan">
                                  Mark Syllabus
                                </span>
                              </Col>
                              <Col span={12}>
                                <ANTDButton
                                  size="small"
                                  type={"text"}
                                  disabled={returnDisableHandler(cardViewData)}
                                  onClick={() => {
                                    handleMarkSyllbus(cardViewData, "mark");
                                  }}
                                  icon={
                                    <NotMarkedIcon
                                      color={
                                        returnDisableHandler(cardViewData)
                                          ? "#757575"
                                          : ""
                                      }
                                    />
                                  }
                                ></ANTDButton>
                              </Col>
                            </>
                          ) : null}
                        </>
                      ) : (
                        <>
                          {cardViewData &&
                          [
                            "LECTURE",
                            "EXTRA CLASS",
                            "DOUBT CLASS",
                            "PTM",
                            "ORIENTATION",
                          ].includes(cardViewData.eventType) &&
                          cardViewData?.takeAttendance ? (
                            cardViewData.attendanceStatus == "Unmarked" ? (
                              <>
                                <Col span={12} className="d-flex">
                                  <span className="filterSpan">
                                    {!checkValidation()
                                      ? "Take Attendance"
                                      : "View Attendance"}{" "}
                                  </span>{" "}
                                </Col>
                                <Col span={12}>
                                  <ANTDButton
                                    size="small"
                                    color="primary"
                                    onClick={() => {
                                      handleMarkAttendance(
                                        cardViewData,
                                        "mark"
                                      );
                                    }}
                                    icon={<EditSmallIcon />}
                                    className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                                  ></ANTDButton>
                                </Col>
                              </>
                            ) : (
                              <>
                                <Col span={12} className="d-flex">
                                  <span className="filterSpan">
                                    {!checkValidation()
                                      ? "Edit Attendance"
                                      : "View Attendance"}
                                    &nbsp;
                                  </span>
                                </Col>

                                <Col span={12}>
                                  <ANTDButton
                                    size="small"
                                    color="primary"
                                    onClick={() => {
                                      handleMarkAttendance(
                                        cardViewData,
                                        "edit"
                                      );
                                    }}
                                    icon={<EditAttendanceIcon />}
                                    className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                                  ></ANTDButton>
                                </Col>
                              </>
                            )
                          ) : null}
                        </>
                      )}
                    </>
                    {!isViewOnly &&
                    cardViewData &&
                    cardViewData.lectureContent &&
                    cardViewData.lectureContent.videos &&
                    cardViewData.lectureContent.videos.length ? (
                      <>
                        <Col span={12} className="d-flex">
                          <span
                            className="filterSpan"
                            onClick={() => {
                              handleOpenVideo();
                            }}
                          >
                            View Lecture recording
                          </span>
                        </Col>
                        <Col span={12}>
                          <ANTDButton
                            size="small"
                            type={"primary"}
                            icon={<EyeOutlined />}
                            onClick={() => {
                              handleOpenVideo();
                            }}
                          ></ANTDButton>
                        </Col>
                      </>
                    ) : null}
                    {!isViewOnly &&
                    cardViewData &&
                    cardViewData.lectureContent &&
                    cardViewData.lectureContent.ebooks &&
                    cardViewData.lectureContent.ebooks.length ? (
                      <>
                        <Col span={12} className="d-flex">
                          <span className="filterSpan">View Lecture PDF</span>
                        </Col>
                        <Col span={12}>
                          <StyledDropdown
                            overlay={
                              <Menu
                                items={items}
                                onClick={onClickViewPdf}
                                style={{ padding: "12px" }}
                              />
                            }
                            placement="top"
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <DownOutlined className="filterSpan pl-2" />
                            </a>
                          </StyledDropdown>
                        </Col>
                      </>
                    ) : null}

                    {isUploadAllowedByStatus && canPerformUpload && (
                      <>
                        <Col span={12} className="d-flex">
                          <span className="filterSpan">
                            Upload lecture assets
                          </span>
                        </Col>

                        <Col span={12}>
                          <Tooltip title="Upload lecture assets">
                            <ANTDButton
                              size="small"
                              type="link"
                              disabled={isViewOnly}
                              icon={
                                <UploadOutlined
                                  style={{
                                    fontSize: "18px",
                                    color: isViewOnly ? "gray" : "#008dc4",
                                  }}
                                />
                              }
                              onClick={() => handleUploadClick()}
                            ></ANTDButton>{" "}
                          </Tooltip>
                        </Col>
                      </>
                    )}

                    {!isViewOnly && (
                      <>
                        <Col span={12} className="d-flex">
                          <span
                            className="filterSpan"
                            onClick={() => {
                              handleViewLibrary();
                            }}
                          >
                            View Library
                          </span>
                        </Col>
                        <Col span={12}>
                          <ANTDButton
                            type="text"
                            size="small"
                            onClick={() => {
                              handleViewLibrary();
                            }}
                            icon={<ArrowUpRight></ArrowUpRight>}
                          ></ANTDButton>
                        </Col>
                      </>
                    )}

                    {cardViewData.documentS3Key && (
                      <>
                        <Col span={12} className="d-flex">
                          <span
                            className="filterSpan"
                            onClick={() => {
                              getViewDocumentHandler(cardViewData);
                            }}
                          >
                            View Document
                          </span>
                        </Col>
                        <Col span={12}>
                          <ANTDButton
                            type="text"
                            size="small"
                            onClick={() => {
                              getViewDocumentHandler(cardViewData);
                            }}
                            icon={<ArrowUpRight></ArrowUpRight>}
                          ></ANTDButton>
                        </Col>
                      </>
                    )}
                    <Col span={12} className="d-flex">
                      <span className="filterSpan" onClick={handleQuizClick}>
                        Quiz
                      </span>
                    </Col>
                    <Col span={12}>
                      <ANTDButton
                        type="text"
                        size="small"
                        onClick={handleQuizClick}
                        icon={<ArrowUpRight></ArrowUpRight>}
                      ></ANTDButton>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Collapse>
          </div>
        )}
      </ScheduleDiv>
    </>
  );
}

export default ScheduledLectureCard;
